
export const isProd = true;

export const API_URL = isProd 
  ? 'https://api.cugsgames.com:9443'  
  : 'http://localhost:5000';

export default API_URL;